export const navigationIt: Record<string, string> = {
  'main': 'Principale',
  'administration': 'Amministrazione',
  'toggle_sidebar': 'Attiva/Disattiva Barra Laterale',
  'search_customers_orders': 'Cerca clienti, ordini...',
  'dashboard': 'Dashboard',
  'leads': 'Contatti',
  'products': 'Prodotti',
  'appointments': 'Appuntamenti',
  'appointments_v2': 'Appuntamenti',
  'appointments_v2_description': 'Gestisci i tuoi appuntamenti con viste calendario e funzionalità',
  'measurements': 'Misure',
  'orders': 'Ordini',
  'orders.title': 'Ordini',
  'sales': 'Vendite',
  'invoices': 'Fatture',
  'payment_requests': 'Richieste di Pagamento',
  'payments': 'Pagamenti',
  'invoices_payments': 'Fatture e Pagamenti',
  'alterations': 'Modifiche',
  'reports': 'Rapporti',
  'suppliers': 'Fornitori',
  'inventory': 'Inventario',
  'job_centre': 'Centro Lavori',
  'settings': 'Impostazioni',
  'wishlist': 'Lista Desideri',
  'loyalty': 'Fedeltà',
  'help': 'Aiuto e Consigli',
  'sign_out': 'Disconnetti',
  'import_history': 'Cronologia Importazioni',
  'search_mobile': 'Cerca...',
  'welcome_back': 'Bentornata',
  'language_toggle': 'Cambia lingua',
  'menu': 'Menu',
  'close_menu': 'Chiudi menu',
  'user_menu': 'Menu utente',
  'my_bridal_journey': 'Il Mio Viaggio Nuziale',
};
